import { cardAnatomy } from '@chakra-ui/anatomy';
import {
  createMultiStyleConfigHelpers,
  cssVar,
} from '@chakra-ui/styled-system';

const { defineMultiStyleConfig, definePartsStyle } =
  createMultiStyleConfigHelpers(cardAnatomy.keys);

const $bg = cssVar('card-bg');
const $borderColor = cssVar('card-border-color');

const variantShadow = definePartsStyle(() => ({
  container: {
    _dark: {
      [$bg.variable]: 'colors.cards.bg',
      [$borderColor.variable]: 'colors.border.light',
    },
    _hover: {
      _dark: {
        [$bg.variable]: 'colors.cards.bg-hover',
        [$borderColor.variable]: 'colors.glass-items.icon-hover',
      },
    },
  },
}));

export const cardTheme = defineMultiStyleConfig({
  variants: {
    elevated: variantShadow,
    shadow: variantShadow,
  },
});
